import * as React from "react";
import { useState } from "react";
import { Button, Field, Textarea, tokens, makeStyles } from "@fluentui/react-components";
import ToneSelector, { EmailTone } from "./ToneSelector";

/* global HTMLTextAreaElement */

interface TextInsertionProps {
  insertText: (text: string) => void;
}

const useStyles = makeStyles({
  instructions: {
    fontWeight: tokens.fontWeightSemibold,
    marginTop: "20px",
    marginBottom: "10px",
  },
  textPromptAndInsertion: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  textAreaField: {
    marginLeft: "20px",
    marginTop: "30px",
    marginBottom: "20px",
    marginRight: "20px",
    maxWidth: "50%",
  },
});

const TextInsertion: React.FC<TextInsertionProps> = (props: TextInsertionProps) => {
  const [text, setText] = useState<string>("Testo di esempio...");
  const [selectedTone, setSelectedTone] = useState<EmailTone>("professionale");

  const handleTextInsertion = async () => {
    const promptWithTone = `[Tono: ${selectedTone}]\n${text}`;
    await props.insertText(promptWithTone);
  };

  const handleTextChange = async (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(event.target.value);
  };

  const handleToneChange = (tone: EmailTone) => {
    setSelectedTone(tone);
  };

  const styles = useStyles();

  return (
    <div className={styles.textPromptAndInsertion}>
      <ToneSelector selectedTone={selectedTone} onToneChange={handleToneChange} />
      <Field className={styles.textAreaField} size="large" label="Inserisci qui il testo da inserire nella mail.">
        <Textarea size="large" value={text} onChange={handleTextChange} />
      </Field>
      <Field className={styles.instructions}>Click the button to insert text.</Field>
      <Button appearance="primary" disabled={false} size="large" onClick={handleTextInsertion}>
        Invia
      </Button>
    </div>
  );
};

export default TextInsertion;
